// Web3 vulnerabilities data for the scanner
export const web3Vulnerabilities = [
  {
    name: 'Reentrancy Attack',
    severity: 'CRITICAL',
    code: `function withdraw(uint amount) public {
    require(balances[msg.sender] >= amount);
    (bool success,) = msg.sender.call{value: amount}("");
    require(success);
    balances[msg.sender] -= amount; // ⚠️ CTF: ANDR31{r3_3ntr4ncy}
}`,
    exploit: 'Attacker can recursively call withdraw() before balance is updated',
    fix: 'Use Checks-Effects-Interactions pattern or ReentrancyGuard'
  },
  {
    name: 'Integer Overflow/Underflow',
    severity: 'HIGH',
    code: `uint256 public totalSupply = 100;
function burn(uint256 amount) public {
    totalSupply -= amount; // ⚠️ Can underflow to max uint256
}`,
    exploit: 'Underflow causes totalSupply to wrap to 2^256-1',
    fix: 'Use Solidity 0.8.x SafeMath or unchecked blocks carefully'
  },
  {
    name: 'Access Control Bypass',
    severity: 'CRITICAL',
    code: `function setOwner(address newOwner) public {
    owner = newOwner; // ⚠️ No access control!
}`,
    exploit: 'Anyone can call setOwner() and take control of contract',
    fix: 'Add require(msg.sender == owner) or use OpenZeppelin Ownable'
  },
  {
    name: 'Front-Running (MEV)',
    severity: 'MEDIUM',
    code: `function buyToken(uint256 amount) public {
    uint256 price = getPrice(); // ⚠️ Public mempool exposure
    require(msg.value >= price * amount);
    transfer(msg.sender, amount);
}`,
    exploit: 'Bots can see transaction and front-run with higher gas',
    fix: 'Use commit-reveal scheme or private mempools (Flashbots)'
  },
  {
    name: 'Unchecked External Call',
    severity: 'HIGH',
    code: `function sendReward(address recipient) public {
    recipient.call{value: 1 ether}(""); // ⚠️ Return value ignored
    emit RewardSent(recipient);
}`,
    exploit: 'If call fails silently, event emits but no funds transferred',
    fix: 'Check return value: (bool success,) = ...; require(success);'
  },
  {
    name: 'Timestamp Dependence',
    severity: 'MEDIUM',
    code: `function random() public view returns(uint) {
    return uint(keccak256(abi.encodePacked(block.timestamp))); // ⚠️
}`,
    exploit: 'Miners can manipulate block.timestamp by ~15 seconds',
    fix: 'Use Chainlink VRF or commit-reveal for randomness'
  }
];

// Hacking quotes
export const hackingQuotes = [
  '"The best way to predict the future is to invent it." - Alan Kay',
  '"Talk is cheap. Show me the code." - Linus Torvalds',
  '"Hackers are breaking the systems for profit. Before, it was about intellectual curiosity." - Kevin Mitnick',
  '"Security is a process, not a product." - Bruce Schneier',
  '"The only truly secure system is one that is powered off." - Gene Spafford',
  '"Penetration testing is like a fire drill for your network." - Unknown',
  '"In God we trust; all others must bring data." - W. Edwards Deming'
];

// Security constants
export const ADMIN_PASSWORD_HASH = 'f0b8649dbd8cc269a6a9f57166490602cb5e17344007e29c1591f6cdad29aa37';

// Hash password utility
export const hashPassword = async (password) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};
